export default __webpack_public_path__ + "static/cake-c02246f1e1e15c5fd0942bf07309359c.jpg";